import React from 'react';

const Editor = React.lazy(() => import('./global').then(() => import('./Editor')));

export default Editor;
